import apiClient from '@/shared/services/apiClient';
import { isAbsoluteUrl, normalizeDownloadPath } from '../utils/pdfDownload';

const API_VERSION = 2;
const RESOURCE_URL = '/api/gestaocarga';
const FETCH_TIMEOUT = 30000;
const PRINT_TIMEOUT = 120000;

export default {
  fetchSheet(cargaId) {
    return apiClient.get(RESOURCE_URL + '/' + cargaId + '/minuta-calculo', {
      apiVersion: API_VERSION,
      timeout: FETCH_TIMEOUT,
    });
  },

  printSheet(cargaId) {
    return apiClient.post(
      RESOURCE_URL + '/calculo/carga/imprimir',
      { carga_id: cargaId },
      { apiVersion: API_VERSION, timeout: PRINT_TIMEOUT }
    );
  },

  resolvePdfUrl(href) {
    if (!href) return null;
    if (isAbsoluteUrl(href)) return href;

    const path = normalizeDownloadPath(href);
    if (path === '') return null;

    return apiClient.resolveUrl(path, { apiVersion: API_VERSION });
  },
};
